import { Injectable, signal } from '@angular/core';

const INSTALL_KEY = 'pwaInstallDismissed';

@Injectable({ providedIn: 'root' })
export class PwaInstallService {
  readonly canInstall = signal(false);

  private deferredPrompt: BeforeInstallPromptEvent | null = null;

  constructor() {
    if (typeof window === 'undefined') { return; }

    window.addEventListener('beforeinstallprompt', (e: Event) => {
      e.preventDefault();
      this.deferredPrompt = e as BeforeInstallPromptEvent;
      this.canInstall.set(true);
    });

    // Browser fires this after the user installs via our prompt or the browser's own UI.
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.canInstall.set(false);
      localStorage.setItem(INSTALL_KEY, '1');
    });
  }

  async install(): Promise<void> {
    if (!this.deferredPrompt) { return; }
    await this.deferredPrompt.prompt();
    await this.deferredPrompt.userChoice;
    this.deferredPrompt = null;
    this.canInstall.set(false);
  }
}
